module.exports = __webpack_public_path__ + "static/media/webflow.06a056e6.jpg";